import React from 'react';
import { Helmet } from 'react-helmet';

import LegalDocument from '../../components/LegalDocument';

function PolicyEs() {
  return (
    <LegalDocument title="Política de Privacidad">
      <Helmet>
        <meta
          name="description"
          content="FECHA DE VIGENCIA: 1° de junio de 2018"
        />
        <meta
          itemprop="description"
          content="FECHA DE VIGENCIA: 1° de junio de 2018"
        />
        <meta
          property="og:description"
          content="FECHA DE VIGENCIA: 1° de junio de 2018"
        />
      </Helmet>
      <p>FECHA DE VIGENCIA: 1° de junio de 2018</p>
      <h4>Información de carácter general</h4>
      <p>
        LEA DETENIDAMENTE ESTA DECLARACIÓN DE PRIVACIDAD Y AVISO DE PRÁCTICAS DE
        PRIVACIDAD.
      </p>
      <p>
        Esta Declaración de Privacidad y Aviso de Prácticas de Privacidad
        (“Política de Privacidad”) establece las prácticas de privacidad de Spur
        y sus afiliados, subsidiarias, agentes, representantes, sucesores y
        cesionarios (colectivamente “Spur”) ubicados en los Estados Unidos. A
        los efectos de los siguientes términos, las referencias a “Nosotros”,
        “Nos” y “Nuestro” incluyen a Spur y sus filiales, subsidiarias, agentes,
        representantes, sucesores y cesionarios. Creamos un mercado para
        conectar eficientemente a las empresas y a los trabajadores que
        coincidan con la disponibilidad y las necesidades de cada uno. Estas
        ofertas se definen en esta Política de Privacidad colectiva e
        individualmente como nuestros “Servicios”.
      </p>
      <p>
        Esta Política de Privacidad es aplicable a toda la recopilación de datos
        por parte de Spur y se aplicará al uso que el usuario (“Usted” o “Su”)
        haga de este sitio web, al uso de cualquier sitio web de terceros
        afiliados que pueda contener un enlace a esta Política de Privacidad, a
        cualquier página, instalación, servicio o capacidad accesible en o por
        cualquier dominio de nivel superior de Spur que sea propiedad de Spur o
        por cualquier subsitio, subdominio, subdirectorio, sitio virtual o
        directorio virtual de los mismos (cada uno de ellos, un “Sitio”, y de
        manera colectiva, los “Sitios”) y a los servicios.
      </p>
      <p>
        Esta Política de Privacidad se aplicará estrictamente a la información
        del cliente recopilada en los Estados Unidos. Esta Política de
        Privacidad expone cómo Spur maneja su uso de los sitios, incluyendo la
        recolección, almacenamiento, transferencia, intercambio, divulgación y
        manejo de su información personal y su uso de nuestros servicios.
      </p>
      <p>
        Al utilizar nuestros servicios, usted reconoce que ha leído esta
        Política de Privacidad y da su consentimiento a las prácticas de
        privacidad de Spur según lo expuesto en la misma, incluyendo nuestro uso
        y divulgación de su información personal para los propósitos descritos a
        continuación. Además, usted confirma su consentimiento al enviar
        contenido o materiales a nuestros servicios o a través de ellos.
      </p>
      <p>
        Nos tomamos muy en serio la privacidad de su información personal. Si
        tiene alguna pregunta o inquietud acerca de esta Política de Privacidad
        o de su información personal, por favor contáctenos directamente a la
        dirección de correo electrónico o postal indicada en la Sección 2
        (Contacto y Comunicación Electrónica).
      </p>
      <h4>Cambios y Actualizaciones a esta Política de Privacidad</h4>
      <p>
        Spur se reserva el derecho de revisar o actualizar esta Política de
        Privacidad en cualquier momento, y usted está obligado a aceptar esas
        revisiones o actualizaciones. Spur le notificará de cualquier cambio en
        la Política de Privacidad publicando la Política de Privacidad revisada
        o actualizada y su fecha de entrada en vigor en los sitios. Su uso de
        los sitios a partir de entonces representa la aceptación de la Política
        de Privacidad y sus revisiones o actualizaciones. Usted debe leer
        periódicamente la Política de Privacidad para enterarse de cualquier
        revisión o actualización. Esta Política de Privacidad forma parte de las
        “Condiciones Generales de Servicio” que se aplican en lo que respecta al
        uso de los sitios y nuestros servicios, las cuales precisamos a
        continuación en esta Política de Privacidad. Si usted no está de acuerdo
        con los términos y condiciones de esta Política de Privacidad,
        incluyendo el uso de su información personal en cualquiera de las formas
        que serán descritas, por favor no nos proporcione su información ni
        utilice los sitios.
      </p>
      <h4>Contacto y Comunicación Electrónica</h4>
      <p>
        Al utilizar nuestros servicios o al proporcionarnos su información
        personal, usted acepta que podemos comunicarnos con usted
        electrónicamente en lo que respecta a cualquier obligación legal,
        reglamentaria, técnica, de seguridad, de privacidad y cualquier
        obligación administrativa o de notificación al consumidor que pueda
        estar relacionada con su uso de los servicios. Si tiene alguna pregunta
        acerca de esta Política de Privacidad o acerca de nuestros servicios
        relacionados con la Política de Privacidad, puede comunicarse con Spur
        por correo electrónico a Legal@SpurJobs.com.
      </p>
      <p>También puede contactarnos en:</p>
      <p>
        Spur, Inc.
        <br />
        Atención: Legal
        <br />
        P.O. Box 107
        <br />
        Huntsville, Alabama 35804
      </p>
      <h4>Tipos de información recopilada y cómo se recopila</h4>
      <p>
        La información que recopilamos de usted cuando accede a nuestro sitio o
        utiliza nuestros servicios se enumera a continuación. Spur puede
        compartir su Información con sus afiliados, subsidiarias, socios y otros
        terceros, tales como terceros que ayudan a operar los sitios y las bases
        de datos relacionadas y nuestras aplicaciones móviles. El uso de
        terceros está sujeto a los términos de uso y a las políticas de
        privacidad de dichos terceros. Spur no es responsable de las prácticas
        de privacidad de otros sitios web o de terceros. Usted debe revisar los
        términos de uso y las políticas de privacidad que son publicadas por
        esos terceros antes de usar cualquier servicio que ellos provean. Spur
        no asume ninguna responsabilidad por cualquier información, producto,
        anuncio, contenido, servicio o software accesible a través de estos
        sitios web de terceros o por cualquier acción que usted pueda tomar como
        resultado del vínculo con cualquiera de dichos sitios web. Recopilamos
        información directamente de usted a través del uso de nuestros sitios,
        aplicaciones móviles o servicios, o de terceros que trabajan con Spur
        para prestar nuestros servicios.
      </p>
      <h4>
        Información personal que le pedimos a usted y verificación de
        antecedentes
      </h4>
      <p>
        Ciertas áreas de los sitios (por ejemplo, la creación de una cuenta de
        usuario, ya sea como Trabajador o como Lugar de Trabajo (dichos términos
        se definen en los Términos de Servicio)) requerirán que usted
        proporcione información personal a Spur. Esa información personal puede
        incluir su nombre, número de teléfono, dirección de correo electrónico,
        dirección postal, código postal, nombre de usuario, contraseña,
        información de tarjeta de crédito, número de seguro social, fecha de
        nacimiento, historial criminal, información de cuenta bancaria, estado
        de ciudadanía, experiencia laboral previa, antecedentes educativos y
        número de identificación federal de empleo. Como parte del proceso de
        contratación o registro de la cuenta, Spur o sus afiliados pueden
        solicitarle que proporcione una copia de su licencia de conducir,
        pasaporte, identificación militar u otra tarjeta de identificación
        personal.
      </p>
      <p>
        Nosotros, o nuestros agentes o representantes designados, podemos
        solicitar sus antecedentes, incluida la información personal disponible,
        a una agencia de informes del consumidor en relación con su solicitud de
        utilizar el sitio para fines laborales. La Ley de Informes de Crédito
        Justos (Fair Credit Reporting Act, o “FCRA”) define dicho informe,
        incluyendo los informes investigativos de los consumidores precisados en
        la FCRA, como un “Informe del Consumidor”, y todas las consultas se
        limitan a la información que afecta su desempeño en posibles Empleos
        (dicho término se define en los Términos de Servicio) en nuestro sitio.
        Todas las solicitudes se llevan a cabo de conformidad con las leyes
        aplicables, incluida la FCRA. Usamos una agencia externa para esta
        investigación: Yardstik, Inc., 100 Washington Ave S, Suite 600,
        Minneapolis, MN 55401, Teléfono: 1-888-278-5042. Como resultado,
        Yardstik puede obtener un Informe del Consumidor sobre usted como usuario
        del sitio.
      </p>
      <p>
        <strong>**Autorización y Divulgación**</strong> De conformidad con la
        Ley de Informes de Crédito Justos de los Estados Unidos, usted autoriza
        a Spur y a sus agentes y representantes designados a llevar a cabo una
        revisión completa de sus antecedentes a través de un Informe del
        Consumidor y/o un informe investigativo del consumidor que se generará
        para la preselección de Empleos en nuestro sitio. Al aceptar esta
        Política de Privacidad, usted reconoce y acepta que ha leído
        cuidadosamente y entendido esta divulgación para la obtención de
        Informes del Consumidor. De igual forma, usted entiende que la
        información guardada en su cuenta o divulgada por usted antes o durante
        el uso de nuestro sitio, en dado caso, puede ser utilizada con el
        propósito de obtener Informes del Consumidor y/o informes investigativos
        del consumidor. Al aceptar esta Política de Privacidad, usted autoriza a
        las agencias de cumplimiento de la ley, instituciones de aprendizaje
        (incluyendo escuelas y universidades públicas y privadas), oficinas de
        servicios de información, oficinas de crédito, repositorios de
        registros/datos, tribunales (federales, estatales, locales o
        internacionales), agencias de registros de vehículos automotores, sus
        empleadores anteriores o actuales, el ejército y otras personas y
        fuentes a proporcionar toda la información sobre usted que solicite la
        agencia de informes del consumidor. Usted garantiza que la información
        que proporciona para que Spur o sus agentes o representantes designados
        puedan obtener un Reporte del Consumidor es verdadera y correcta y será
        válida para cualquier reporte que pueda ser solicitado por o en nombre
        de Spur.
      </p>
      <p>
        Además, algunos Lugares de Trabajo pueden tener requisitos adicionales
        de verificación de antecedentes que necesitarán de usted antes de
        aceptarlo como Trabajador. Dichos Lugares de Trabajo pueden compartir la
        información que recopilan sobre usted a través de sus propias
        comprobaciones de antecedentes con nosotros y otros terceros,
        incluyendo, sin limitación, agencias gubernamentales y reguladoras, de
        acuerdo con los términos de la comprobación de antecedentes específicos
        del Lugar de Trabajo. No controlamos los criterios de los Lugares de
        Trabajo para recopilar o compartir información sobre usted a través de
        sus comprobaciones de antecedentes independientes. Revise detenidamente
        los términos y condiciones de cualquier comprobación de antecedentes
        independiente que se le exija en los Lugares de Trabajo.
      </p>
      <p>
        Si bien es usted quien decide si desea proporcionar la información
        solicitada o no, no podemos ofrecerle determinados servicios si no
        proporciona cierta información. Al enviar esta información personal a
        Spur, usted acepta que Spur pueda usar la información de acuerdo con
        esta Política de Privacidad, por ejemplo, para proporcionarle los
        servicios, emparejar a los Trabajadores con oportunidades de contacto,
        ajustar y mejorar los servicios de Spur para que se adapten mejor a sus
        necesidades y para cumplir con los requisitos legales, reglamentarios o
        contractuales relacionados con los servicios que se le proporcionan. Si
        usted envía dicha información personal a Spur, Spur puede compartir esa
        información con terceros según lo establecido en esta Política de
        Privacidad, además de usar dicha información para los fines por los que
        fue enviada inicialmente.
      </p>
      <p>
        Spur también puede utilizar la información personal de otras maneras,
        tales como para proporcionarle información sobre servicios y ofertas que
        puedan ser de su interés, para hacerle seguimiento acerca de sus
        experiencias con Spur, o según se le revele en el momento de la
        recolección. Cuando sea necesario, Spur solicitará su consentimiento
        expreso para enviar dichos mensajes, incluso cuando se envíen por correo
        electrónico u otro tipo de mensaje electrónico comercial. Este
        consentimiento es solicitado por Spur, P.O. Box 107, Huntsville, Alabama
        35804. Usted puede revocar su consentimiento utilizando el enlace
        “Unsubscribe” (cancelar la suscripción) ubicado en la parte inferior de
        los mensajes que recibe de Spur, o poniéndose en contacto con Spur a
        través del correo electrónico o la dirección postal que figura en su
        acuerdo de usuario aplicable.
      </p>
      <p>
        Spur puede compartir su información personal con sus afiliados,
        subsidiarias y socios y con otros terceros. Además, en la medida en que
        lo exija la ley federal o estatal aplicable, es posible que se le exija
        a Spur que revele su información personal en respuesta a solicitudes
        legales de las autoridades públicas, incluso para cumplir con requisitos
        normativos, de seguridad nacional o de cumplimiento de la ley. Al enviar
        información personal a Spur, usted autoriza a Spur a recibirla,
        revisarla, editarla, almacenarla y utilizarla para los fines descritos
        en esta Política de Privacidad.
      </p>
      <h4>Otros tipos de información que recopilamos</h4>
      <p>
        Spur también recopila cierta información sobre sus preferencias de
        trabajo, cómo utiliza los servicios, su disponibilidad, el uso de los
        sitios de Spur (incluyendo el número de visitantes únicos, la frecuencia
        de las visitas), la forma en que los usuarios interactúan con los
        sitios, las preferencias de experiencia del usuario, la dirección IP y
        otra información que puede ayudar a Spur a mejorar la experiencia del
        cliente, mitigar la actividad fraudulenta y cumplir con los requisitos
        legales. Dicha información puede incluir, pero no se limita a, lo
        siguiente:
      </p>
      <h4>Información de registro</h4>
      <p>
        Cuando usted visita los sitios web de Spur, nosotros automáticamente
        recopilamos y almacenamos cierta información en los registros de nuestro
        servidor. Este tipo de información incluye detalles de cómo usted
        interactuó con nuestros sitios, servicios o aplicaciones. Puede incluir
        información como: Dirección IP, Identificador Único de Dispositivo o
        Identificador Automático de Llamadas (CallerID/ANI), contenido de
        páginas web, transacciones con Interfaces de Programación de
        Aplicaciones (Application Program Interface o API), transacciones con
        sistemas de Respuesta Interactiva de Voz (Interactive Voice Response o
        IVR), actividad y contenido de la interacción del visitante con los
        representantes del centro de llamadas, actividad de uso de la
        aplicación, información de hardware, configuración del hardware y del
        sistema, tipo de navegador, idioma del navegador, la fecha y hora de su
        solicitud, URL de referencia, entre otros.
      </p>
      <h4>Recolección automática</h4>
      <p>
        Spur y sus socios utilizan cookies o tecnologías similares para analizar
        tendencias, administrar los sitios de Spur, rastrear los movimientos de
        los usuarios en el sitio y recopilar información demográfica sobre
        nuestra base de usuarios en su totalidad.
      </p>
      <h4>Cookies</h4>
      <p>
        Una cookie es un pequeño archivo de datos que es administrado y
        almacenado en su sistema local por su navegador web u otra aplicación.
        Spur utiliza cookies persistentes y de sesión para, entre otras cosas,
        identificar su computadora durante una interacción particular y analizar
        su comportamiento durante una visita particular. La mayoría de los
        navegadores web le ofrecen la posibilidad de aceptar o rechazar cookies,
        así como de ser advertido cada vez que se envía una cookie. Si decide
        rechazar las cookies, es posible que no pueda utilizar completamente los
        sitios, servicios o aplicaciones de Spur.
      </p>
      <h4>Etiquetas Pixel</h4>
      <p>
        Las etiquetas de píxeles, también conocidas como balizas web, ayudan a
        Spur a gestionar mejor la experiencia del usuario y el seguimiento del
        contenido. Las etiquetas de píxel son pequeños gráficos con un
        identificador único, las cuales proporcionan una función similar a las
        cookies y se utilizan para rastrear la interacción del usuario con el
        contenido proporcionado por Spur o una organización afiliada. A
        diferencia de las cookies, que se almacenan en el disco duro del
        ordenador del usuario, las etiquetas de píxel se incrustan de forma
        invisible en el contenido. El pequeño tamaño y la transparencia de las
        etiquetas de píxel no pretenden engañar a los destinatarios del
        contenido, sino minimizar la distracción.
      </p>
      <h4>Fuentes de datos de terceros</h4>
      <p>
        Spur puede aprovechar fuentes de datos externas para proporcionar
        contexto y antecedentes sobre los usuarios de sus sitios, servicios o
        aplicaciones móviles con el fin de mejorar la experiencia del cliente,
        mitigar el fraude o la actividad maliciosa, o cumplir con los requisitos
        normativos internos y externos de la empresa.
      </p>
      <h4>Do Not Track y Cookies de Publicidad de Terceros</h4>
      <p>
        Do Not Track es una iniciativa público-privada,
        <a href="https://www.w3.org/2011/tracking-protection/">
          {' '}
          http://www.w3.org/2011/tracking-protection/
        </a>
        , que ha desarrollado una “bandera” técnica o señal que un usuario final
        puede activar dentro de su software de navegación para notificar a los
        sitios web que no desea ser “rastreados” por terceros, según lo definido
        por la iniciativa. Sin embargo, esta iniciativa no ha llegado a un
        consenso sobre las medidas técnicas o de otro tipo que deben adoptar las
        partes que reciben la señal. Como resultado, Do-Not-Track aún no ha sido
        estandarizado y la mayoría de los sitios web, incluyendo los sitios
        Spur, no alteran su comportamiento o cambian sus servicios cuando
        reciben una señal o bandera de “no rastrear”. Sin embargo, usted puede
        tomar decisiones sobre su privacidad y los anuncios que recibe.
      </p>
      <p>
        Algunos de los anuncios que usted recibe en los sitios son
        personalizados en base a las predicciones sobre sus intereses, las
        cuales son generadas a partir de sus visitas a diferentes sitios. A este
        tipo de personalización de anuncios se le denomina publicidad “basada en
        el comportamiento en línea” o “basada en intereses”.
      </p>
      <p>
        Nos asociamos con un tercero para administrar nuestra publicidad en
        otros sitios. Nuestro socio externo puede utilizar cookies o tecnologías
        similares para proporcionarle publicidad basada en sus actividades e
        intereses de navegación. Si desea optar por no participar en la
        publicidad basada en intereses, haga clic aquí. Tenga en cuenta que
        seguirá recibiendo anuncios genéricos.
      </p>
      <p>
        Como alternativa a la opción de exclusión, también puede optar por
        bloquear todas las cookies de las primeras partes (como Spur) y de
        terceros (como entidades involucradas en la publicidad) mediante el uso
        de las opciones de bloqueo de cookies incorporadas en el software de su
        navegador. Sin embargo, tenga en cuenta que si decide bloquear las
        cookies, es posible que algunas secciones de los sitios de Spur no
        funcionen correctamente.
      </p>
      <h4>Retención y eliminación de información personal</h4>
      <p>
        Spur retendrá su información personal por el tiempo que sea necesario
        para cumplir con los propósitos por los cuales fue recopilada y para
        cumplir con las leyes aplicables, y su consentimiento para tales
        propósitos sigue siendo válido con respecto a los datos de reclamos y
        para presentar reclamos relacionados con la cobertura de seguro después
        de la terminación de la relación de Spur con usted. Cuando la
        información personal ya no sea necesaria o requerida legalmente, será
        borrada o desidentificada permanentemente para que ya no pueda ser
        asociada con un individuo específico.
      </p>
      <h4>Uso de la información personal</h4>
      <p>
        Además de los usos de información personal mencionados anteriormente,
        Spur puede usar su información recopilada en los sitios para propósitos
        tales como: (a) ayudar a establecer y verificar su identidad; (b)
        activar y mantener su cuenta; (c) ponerse en contacto con usted para
        ofrecerle actualizaciones y avisos del servicio, avisos promocionales e
        información sobre otros servicios disponibles de Spur o sus afiliados;
        (d) proporcionarle servicios que usted haya solicitado o autorizado; (e)
        responder a sus preguntas, consultas, comentarios e instrucciones; (f)
        mejorar los sitios mediante la resolución de problemas técnicos, el
        cálculo de las estadísticas generales de uso, la comercialización
        interna y con fines promocionales, el desarrollo del servicio y la
        mejora del contenido; (g) tomar medidas de buena fe para hacer cumplir
        los términos y condiciones; y (h) mantener la seguridad y la integridad
        de los sitios y de los sistemas de Spur.
      </p>
      <h4>Intercambio y divulgación de información personal</h4>
      <p>
        Podemos compartir o divulgar su información personal en los siguientes
        casos:
      </p>
      <ul>
        <li>
          Para realizarle un servicio. Por ejemplo, si usted nos envía una
          pregunta por correo electrónico, podremos utilizar su dirección de
          correo electrónico para procesar la solicitud y responder a su
          pregunta.
        </li>
        <li>
          Para proporcionarle los servicios. Divulgaremos su información de
          contacto según sea necesario a los Trabajadores que usted solicite, de
          esa forma podrán comunicarse con usted para proporcionarle los
          servicios. Esto se establece en un acuerdo escrito independiente entre
          usted y nosotros.
        </li>
        <li>
          Para ofrecerle productos de nuestros afiliados, socios estratégicos,
          agentes o de terceros vendedores y otras partes no afiliadas que
          consideramos pueden ser de su interés, o ayudar a dichas partes con
          fines de investigación, administrativos y/o comerciales. Estas partes
          están obligadas por contrato a utilizar únicamente la información que
          se les proporciona para los fines especificados por Spur.
        </li>
        <li>
          A terceros proveedores de servicios, agentes o contratistas
          independientes no afiliados que nos ayuden a mantener nuestros
          servicios y nos proporcionen otros servicios administrativos
          (incluyendo, pero sin limitarse a, proporcionar a Spur seguro,
          procesamiento y cumplimiento de pedidos, proporcionar servicio al
          cliente, mantener y analizar datos y enviar comunicaciones de clientes
          en nuestro nombre). Spur exige a estas empresas de servicios que
          cumplan contractualmente con los principios establecidos en la
          Política de Privacidad, y les exige que utilicen dicha información
          únicamente para los fines por los cuales se les ha facilitado.
        </li>
        <li>
          Para completar la compra de los servicios. Si usted decide realizar
          una compra de uno de nuestros servicios, es posible que le pidamos su
          número de tarjeta de crédito, dirección de facturación y otra
          información relacionada con la realización de dicha compra, y es
          posible que utilicemos dicha información para realizar su compra.
          También podemos proporcionar dicha información, u otra información
          personal proporcionada por usted, a terceros no afiliados para
          completar su compra (por ejemplo, para procesar su tarjeta de
          crédito). Estos terceros están obligados contractualmente a utilizar
          la información proporcionada sólo para los fines especificados por
          Spur.
        </li>
        <li>
          Para pagarte. Si usted se convierte en usuario de Spur, podemos
          pedirle su cuenta bancaria y otra información necesaria para
          transferirle sus ganancias. También podemos proporcionar dicha
          información, u otra información personal proporcionada por usted, a
          terceros no afiliados para completar nuestro pago dirigido a usted.
          Estos terceros están obligados contractualmente a utilizar la
          información proporcionada sólo para los fines especificados por Spur.
        </li>
        <li>
          Para cumplir con la ley (o en la creencia de buena fe de que dicha
          acción es necesaria para cumplir con los requisitos de la ley); para
          cumplir con el proceso legal que se nos ha notificado; para proteger y
          defender nuestros derechos o propiedad, incluyendo nuestros derechos y
          propiedad y nuestros servicios; y para actuar en circunstancias
          urgentes al proteger su seguridad personal y la de nuestros otros
          visitantes.
        </li>
        <li>
          Podemos utilizar información anónima o general derivada de los datos
          que recopilamos de usted y agregarla a la información de nuestros
          otros clientes y visitantes (“Datos agregados no identificables”) para
          nuestros fines comerciales, incluidos, entre otros, el análisis de las
          necesidades de los clientes y la mejora de nuestros servicios. Seremos
          propietarios de todos los derechos, títulos e intereses sobre dichos
          datos agregados no identificables. Sus datos pueden ser copropiedad de
          terceros no afiliados con nosotros.
        </li>
        <li>
          Para evitar el fraude y el fraude potencial. Podemos verificar la
          información que usted nos proporciona al obtener nuestros servicios a
          través de terceros, a quienes se les prohíbe contractualmente usar
          cualquier información que les proporcionemos para cualquier propósito
          no especificado por Spur. En el curso de dicha verificación, podríamos
          recibir información personal adicional sobre usted de dichos
          servicios. Si usted utiliza una tarjeta de crédito o de débito para
          comprar nuestros servicios, podremos utilizar los servicios de
          autorización de tarjetas y de detección de fraude para verificar que
          la información de su tarjeta y la dirección coincidan con la
          información que usted nos proporcionó, y que la tarjeta no ha sido
          reportada como perdida o robada.
        </li>
        <li>
          Para comercializar nuestros sitios, servicios y aplicaciones móviles.
          Podemos utilizar la información que usted proporciona en su perfil en
          nuestros materiales de mercadeo a terceros, tal como su nombre, foto,
          la fecha en que creó su cuenta, su historial de empleo y/o educación,
          trabajos anteriores que usted haya completado o enviado,
          calificaciones de otros usuarios y autodescripción.
        </li>
      </ul>
      <h4>Divulgación legal</h4>
      <p>
        Podemos divulgar información sobre usted y su uso de los servicios si
        creemos que dicha divulgación es razonablemente necesaria para: (i)
        cumplir con la ley y/o el proceso legal cuando se haya realizado una
        solicitud formal (por ejemplo, solicitud de una agencia de supervisión
        administrativa, demanda civil, citación, orden judicial o procedimiento
        judicial o administrativo); (ii) proteger o defender nuestros derechos
        y/o propiedad o los derechos y propiedad de otros; (iii) hacer cumplir
        nuestros Términos Generales de Uso y/o esta Política de Privacidad; (iv)
        responder a reclamos de que el/los contenido(s) de una comunicación
        viola(n) los derechos de otra persona; y (v) cumplir con nuestras
        obligaciones legales y regulatorias, incluyendo, entre otras, las de ser
        un empleador y a los fines fiscales.
      </p>
      <p>
        Asimismo, pueden surgir circunstancias en las que, por razones
        comerciales, podamos decidir reorganizar o desinvertir todo o parte de
        nuestro negocio a través de procedimientos de venta, cesión, fusión,
        adquisición, bancarrota, o podemos adquirir un nuevo negocio. En estas
        circunstancias, la información personal puede ser compartida con los
        compradores o cesionarios reales o potenciales, o con el nuevo negocio
        adquirido.
      </p>
      <h4>Personas menores de 18 años</h4>
      <p>
        Los servicios proporcionados por Spur no están dirigidos o disponibles
        para personas menores de dieciocho (18) años de edad o la mayoría de
        edad legal en su estado. Si usted se entera de que su hijo, siendo menor
        de dieciocho (18) años o menor que la edad legal dictaminada en su
        estado, está accediendo a los servicios y proporcionando información
        personal sin su consentimiento, por favor contáctenos utilizando la
        información facilitada en la sección Contacto y Comunicación Electrónica
        de esta Política de Privacidad. Spur tomará medidas para eliminar la
        información personal del niño de los sistemas de recolección de datos y
        cancelar la cuenta de su hijo. Esto ocurrirá cada vez que Spur determine
        que cualquier persona menor que la mayoría de edad establecida en su
        estado o jurisdicción ha accedido a los servicios.
      </p>
      <h4>Seguridad de la información</h4>
      <p>
        Cualquier información enviada a través de Internet, incluso a través de
        un sitio web, aplicación móvil o correo electrónico, está sujeta a
        intercepción o enrutamiento incorrecto; Internet no es un canal de
        comunicación totalmente seguro. Por favor considere esto antes de enviar
        cualquier información a Spur a través de los sitios o de una aplicación
        móvil. A pesar de que Spur sigue los estándares generalmente aceptados
        por la industria para proteger la información que se nos envía, ningún
        método de transmisión a través de Internet, o método de almacenamiento
        electrónico, es completamente seguro. Por lo tanto, aunque Spur se
        esfuerza por utilizar medios comercialmente aceptables para proteger su
        información personal, Spur no puede garantizar su seguridad absoluta.
        Para obtener mayor información sobre el procesamiento de tarjetas de
        crédito y la seguridad de los datos, consulte estas secciones
        específicas de esta Política de privacidad.
      </p>
      <h4>Procesamiento de tarjetas de crédito y seguridad de datos</h4>
      <p>
        Spur no recibe ni distribuye fondos directamente de o a usted cuando
        utiliza los sitios o servicios. Spur utiliza una pasarela de
        procesamiento de pagos y facturación de terceros, proporcionada por
        Stripe, Inc., la cual ofrece la infraestructura y la seguridad
        necesarias para proveer una transmisión segura de los datos de las
        transacciones de su tarjeta de crédito. Los términos de servicio de
        Stripe, Inc. están disponibles en{' '}
        <a href="https://stripe.com/us/legal"> https://stripe.com/us/legal</a> y
        su política de privacidad está disponible en{' '}
        <a href="https://stripe.com/us/privacy">
          {' '}
          https://stripe.com/us/privacy
        </a>
        , los cuales se incorporan como referencia en el presente documento.
        Spur sólo puede aceptar tarjetas de crédito para su procesamiento a
        través de nuestra pasarela de procesamiento de pagos seguros. Aunque no
        controlamos el entorno de seguridad y no podemos garantizar el
        procesamiento seguro de los datos de las transacciones de su tarjeta de
        crédito, queremos informarle que nuestro procesador de tarjetas de
        crédito cumple con el Estándar de Seguridad de Datos para la Industria
        de Tarjetas de Pago (“PCI DSS”) como proveedor de servicios de Nivel 1.
        Nosotros exigimos que nuestros procesadores de tarjetas de crédito
        cumplan con PCI DSS. PCI DSS es el estándar de seguridad más estricto de
        la industria de tarjetas bancarias. Ejemplos de las medidas de seguridad
        de nuestro procesador de tarjetas de crédito incluyen: salvaguardas
        físicas, electrónicas y de procedimiento; herramientas sofisticadas de
        monitoreo de seguridad; políticas de seguridad documentadas; uso de
        cifrado fuerte para la transmisión de información de pedidos para y de
        parte de nuestros clientes; restricción del acceso a la información
        personal; y auditorías de seguridad periódicas por parte de terceros
        expertos en seguridad.
      </p>
      <h4>Redes Sociales</h4>
      <p>
        Cualquier información, comunicación o material de cualquier tipo o
        naturaleza que usted envíe a los sitios o a través de los servicios de
        Spur (incluyendo, pero sin limitarse a, cualquier sitio Spur incluido en
        una plataforma de redes sociales o sitio web como Facebook, Instagram o
        Twitter), por correo electrónico, publicación, mensajería, carga,
        descarga o de otro modo (colectivamente, un “Envío”), se realiza bajo su
        propio riesgo y sin ninguna expectativa de privacidad. Spur no puede
        controlar las acciones de otros usuarios de cualquier plataforma de
        redes sociales o sitio web; por lo tanto, Spur no es responsable de
        ningún contenido o envío incluido en dichos sitios y plataformas. Al
        visitar cualquier sitio Spur que esté incluido en una plataforma de
        redes sociales o sitio web, usted está garantizándole a Spur que ha
        revisado la Política de Privacidad aplicable y los términos de uso de
        dicha plataforma o sitio web y que usted cumplirá con todas las
        disposiciones incluidas en la misma. Además, en el caso de que Spur
        ofrezca un tablón de mensajes o cualquier otra función interactiva o de
        tipo social en los sitios, tenga en cuenta que estas áreas pueden
        permitirle publicar y compartir con otros usuarios ciertos mensajes,
        contenido u otra información (por ejemplo, historias, fotografías,
        consejos, entre otros). Aunque Spur puede tomar ciertas precauciones
        para proteger a aquellos que utilizan estas áreas de los sitios, Spur le
        anima a ser cauteloso de proporcionar cualquiera de sus datos personales
        en dichos foros públicos. La información que usted envía puede ser
        recopilada y utilizada por personas que usted no conoce. Spur no
        garantiza la privacidad y seguridad de estas áreas y por lo tanto no es
        responsable de ninguna información que usted elija enviar. El uso de
        estas funciones es totalmente bajo su propio riesgo.
      </p>
      <h4>Usuarios internacionales</h4>
      <p>
        Si usted nos visita desde la Unión Europea u otras regiones con leyes
        que rigen la recopilación y el uso de datos diferentes a las leyes de
        los Estados Unidos, tenga en cuenta que está transfiriendo información
        acerca de usted, incluyendo información personal, a un país y
        jurisdicción que no tiene las mismas leyes de protección de datos que la
        Unión Europea. Por consiguiente, usted estará consintiendo la
        transferencia de dicha información a los Estados Unidos y el uso y la
        revelación de la misma tal como se describe en esta Política de
        Privacidad.
      </p>
      <h4>Monitoreo y aplicación de la ley</h4>
      <p>
        Spur ha implementado varias medidas para monitorear el cumplimiento y
        hacer respetar los elementos de esta Política de Privacidad. Si usted
        tiene una pregunta, queja o disputa relacionada con la privacidad de
        Spur, por favor contáctenos a través del correo postal o electrónico que
        fue facilitado en la sección de Contacto y Comunicación Electrónica de
        esta Política de Privacidad.
      </p>
    </LegalDocument>
  );
}

export default PolicyEs;
